import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// COMPONENTES
import { ResumenOrderComercioComponent } from './resumen-order/resumen-order.component';
import { CondicionesComponent } from './condiciones/condiciones.component';
import { PedidoComponent } from './pedido/pedido.component';
import { ComercioComponent } from './comercio/comercio.component';
import { OrderResponseComercioComponent } from './order-response-comercio/order-response-comercio.component';
import { OrderConfirmComercioComponent } from './order-confirm-comercio/order-confirm-comercio.component'; 
import { ReviewComercioComponent } from './review-comercio/review-comercio.component';


@NgModule({
  declarations: [
    ResumenOrderComercioComponent,
    CondicionesComponent,
    PedidoComponent,
    ComercioComponent,
    OrderResponseComercioComponent,
    OrderConfirmComercioComponent,
    ReviewComercioComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule
  ]
})
export class OrderComercioModule { }
